import { render, staticRenderFns } from "./IntCard.vue?vue&type=template&id=75937b61&scoped=true&"
import script from "./IntCard.vue?vue&type=script&lang=js&"
export * from "./IntCard.vue?vue&type=script&lang=js&"
import style0 from "./IntCard.vue?vue&type=style&index=0&id=75937b61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75937b61",
  null
  
)

export default component.exports